import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AxiosError } from "axios";
import { EmitSuccessAlert } from "../../../utils/EmitSuccessAlert";
import { EmitError } from "../../../utils/EmitError";
import { ISubjectContact } from "../../HelpAndSupport/interfaces";
import SubjectHelpAndSupportService from "../../../services/http/services/SubjectHelpAndSupportService";

export default function useEditSubjectHelpAndSupport() {
    const { id } = useParams();
    const [subject, setSubject] = useState<ISubjectContact>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const navigate = useNavigate();

    useEffect(() => {
        const controller = new AbortController();

        async function loadSubject() {
            try {
                setIsLoading(true);
                const subjectData = await SubjectHelpAndSupportService.getSubjectById(Number(id), controller.signal);

                setSubject(subjectData);
                setIsLoading(false);
            } catch (err) {
                if (err instanceof AxiosError && err.name === 'CanceledError') {

                    return;
                }

                setIsLoading(false);

                EmitError(err, true, 'editSubject_sdopasdasd');

                navigate('/configuracoes/assuntos-ajuda-e-suporte');
            }
        }

        loadSubject();

        return () => {
            controller.abort();
        }
    }, [id, navigate]);

    async function handleSubmit(subjectData: FormData) {
        try {
            await SubjectHelpAndSupportService.updateSubject(Number(id), subjectData);

            EmitSuccessAlert('Assunto atualizado com sucesso!');

            navigate('/configuracoes/assuntos-ajuda-e-suporte');
        } catch (err) {
            EmitError(err, true, 'editSubject_aspaiopsdhjaq');
        }
    }

    return {
        isLoading,
        handleSubmit,
        subject,
    }
}
